import { string, object, SchemaOf } from 'yup'
import { unMaskInputs } from '../../utils'
import cpfIsValid from '../../utils/validators/cpfIsValid'

export interface IProfileSchema {
    name: string
    email: string
    cpf: string
    currentPassword: string
}

const profileSchema: SchemaOf<IProfileSchema> = object().shape({
    name: string().required('Preencha o campo com seu nome.'),
    email: string().email('E-mail inválido.').required('Preencha o campo com seu e-mail.'),
    cpf: string()
        .required('Preencha o campo com seu CPF.')
        .min(11, 'O campo CPF está incompleto')
        .test('test-invalid-cpf', 'CPF Inválido.', (cpf) => {
            if (!cpf) return false
            return cpfIsValid(unMaskInputs(cpf))
        }),
    currentPassword: string().required('Preencha o campo com sua senha atual.'),
})

export default profileSchema
